import { TrainSHomeStoreCtx } from '@/stores/TrainStore/TrainSHomeStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import TrainSHomeStationDisplay from './Display/TrainSHomeStationDisplay';
import TrainSHomeStationSwitch from './Switch/TrainSHomeStationSwitch';
import styles from './TrainSHomeStation.module.scss';

const TrainSHomeStation: React.FC = () => {
  const store = useContext(TrainSHomeStoreCtx);

  return (
    <section className={styles.container}>
      <TrainSHomeStationDisplay stationType="DEPARTURE" station={store.departureStation?.name} />
      <TrainSHomeStationSwitch onClick={store.switchStation} />
      <TrainSHomeStationDisplay stationType="ARRIVAL" station={store.arrivalStation?.name} />
    </section>
  );
};

export default observer(TrainSHomeStation);
